function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1908(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 58.26,
    height: 46.52,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.645714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.13,
    y: 23.26,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 46.52,
    width: 58.26,
    height: 57.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.13,
    y: 75.14500000000001,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 103.77,
    width: 58.26,
    height: 57.25,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.178571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.13,
    y: 132.39499999999998,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 161.03,
    width: 58.26,
    height: 57.77,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.22125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.13,
    y: 189.915,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 218.79,
    width: 58.26,
    height: 58.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.322857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.13,
    y: 248.1,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.41,
    width: 58.26,
    height: 75.66,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.709999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.13,
    y: 315.24,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 353.07,
    width: 58.26,
    height: 83.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.709999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.13,
    y: 394.99,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 436.9,
    width: 58.26,
    height: 84.69,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.13,
    y: 479.245,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 521.59,
    width: 58.26,
    height: 87.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.709999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.13,
    y: 565.385,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 609.18,
    width: 58.26,
    height: 90.82,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.419999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.13,
    y: 654.5899999999999,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.26,
    y: 0,
    width: 73.91,
    height: 74.95,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.4775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.215,
    y: 37.475,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.17,
    y: 0,
    width: 75.5,
    height: 74.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.92,
    y: 37.475,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.67,
    y: 0,
    width: 76.69,
    height: 74.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.707142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.015,
    y: 37.475,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.36,
    y: 0,
    width: 78.55,
    height: 74.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.327777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.635,
    y: 37.475,
    fontFamily: "Arial"
  }, "\n        St._Lucie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.9,
    y: 0,
    width: 78.81,
    height: 74.95,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.707142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.30499999999995,
    y: 37.475,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.71,
    y: 0,
    width: 82.25,
    height: 74.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.491666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.835,
    y: 37.475,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.97,
    y: 0,
    width: 85.43,
    height: 74.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.327777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.6850000000001,
    y: 37.475,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 609.4,
    y: 0,
    width: 90.6,
    height: 74.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.707142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.6999999999999,
    y: 37.475,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.26,
    y: 74.95,
    width: 86.84,
    height: 79.45,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.8625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.68,
    y: 114.67500000000001,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.26,
    y: 154.39,
    width: 86.84,
    height: 80.93,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.68,
    y: 194.855,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.26,
    y: 235.33,
    width: 86.84,
    height: 84.36,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.051428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.68,
    y: 277.51,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.26,
    y: 319.69,
    width: 86.84,
    height: 90.53,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.648888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.68,
    y: 364.955,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.26,
    y: 410.22,
    width: 86.84,
    height: 95.22,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.68,
    y: 457.83000000000004,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.26,
    y: 505.44,
    width: 86.84,
    height: 95.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.684000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.68,
    y: 553.335,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.26,
    y: 601.24,
    width: 86.84,
    height: 98.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.68,
    y: 650.62,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.1,
    y: 74.95,
    width: 85.86,
    height: 103.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.7325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.03,
    y: 126.515,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.96,
    y: 74.95,
    width: 87.49,
    height: 103.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.498571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.705,
    y: 126.515,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.45,
    y: 74.95,
    width: 92.21,
    height: 103.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.0525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.555,
    y: 126.515,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.66,
    y: 74.95,
    width: 93.56,
    height: 103.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.593333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.44000000000005,
    y: 126.515,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.22,
    y: 74.95,
    width: 94.42,
    height: 103.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.8025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.4300000000001,
    y: 126.515,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 598.65,
    y: 74.95,
    width: 101.35,
    height: 103.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.66875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.3249999999999,
    y: 126.515,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.1,
    y: 178.08,
    width: 117.83,
    height: 97.56,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.015,
    y: 226.86,
    fontFamily: "Arial"
  }, "\n        St._Johns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.1,
    y: 275.64,
    width: 117.83,
    height: 98.23,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.371666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.015,
    y: 324.755,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.1,
    y: 373.87,
    width: 117.83,
    height: 98.49,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.849
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.015,
    y: 423.115,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.1,
    y: 472.36,
    width: 117.83,
    height: 106.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.224285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.015,
    y: 525.645,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.1,
    y: 578.94,
    width: 117.83,
    height: 121.06,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.832857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.015,
    y: 639.47,
    fontFamily: "Arial"
  }, "\n        De_Soto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.93,
    y: 178.08,
    width: 137.73,
    height: 105.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 331.795,
    y: 231.06,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.66,
    y: 178.08,
    width: 148.59,
    height: 105.96,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 474.95500000000004,
    y: 231.06,
    fontFamily: "Arial"
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.25,
    y: 178.08,
    width: 150.75,
    height: 105.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 624.625,
    y: 231.06,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.93,
    y: 284.04,
    width: 131.64,
    height: 127.37,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.195714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.75,
    y: 347.725,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.93,
    y: 411.41,
    width: 131.64,
    height: 135.51,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 32.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.75,
    y: 479.165,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.93,
    y: 546.92,
    width: 131.64,
    height: 153.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.805714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.75,
    y: 623.4599999999999,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.57,
    y: 284.04,
    width: 120.47,
    height: 180.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.078333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.805,
    y: 374.105,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.05,
    y: 284.04,
    width: 184.95,
    height: 180.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.51625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.525,
    y: 374.105,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.57,
    y: 464.16,
    width: 149.94,
    height: 235.84,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.988
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.53999999999996,
    y: 582.08,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.51,
    y: 464.16,
    width: 155.49,
    height: 235.84,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.957500000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 622.255,
    y: 582.08,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1908);
export default __webpack_public_path__ + "static/media/1908.afcdf0f0559fab588fb7cc83a0d315ee.svg";
export { ForwardRef as ReactComponent };